/**
 * Утилиты для фильтрации коллекции
 * Вынесено из legacy-app.js для модульности
 */

/**
 * Активирует фильтр "Все" в коллекции
 * Добавляет класс 'active' к элементу #filter-all
 */
export function activateAllFilter() {
  const filterAllElement = document.getElementById("filter-all");
  if (filterAllElement) {
    filterAllElement.classList.add("active");
  }
}











